import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { registerUser, signInWithGoogle, signInWithApple } from '../../firebase/firebaseAuth';
import './MainPage.css';
import '../../App.css';

function MainPage() {
    const [showRegister, setShowRegister] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        const additionalInfo = {
            name: name,
            // Add any other fields you want to store
        };
        
        const result = await registerUser(email, password, additionalInfo);
        if (result.success) {
            setSuccessMessage('Registration successful!');
            // Clear form fields
            setEmail('');
            setPassword('');
            setName('');
            // Navigate directly to INTP chat after registration
            navigate('/chat/INTP');
        } else {
            setError(result.error);
        }
    };

    return ( 
        <div className="main-page centered-container">
            <div className="main-page">
                <div className="container">
                    <div className="content">
                        <header>
                            <img src="/images/INTP_1.png" alt="TypeTalk Logo" className="logo" />
                        </header>
                        <main>
                            <h1>Sign up or log in</h1>
                            <p className="slogan">Start your personalized MBTI journey today.</p>
                        
                            {!showRegister ? (
                                <>
                                    <button onClick={() => navigate('/signup')} className="button primary-button">
                                        Sign up
                                    </button>
                                    <Link to="/login" className="button secondary-button">
                                        Log in
                                    </Link>
                                </>
                            ) : (
                                <div className="register-form">
                                    <h2>Register</h2>
                                    {error && <p className="error-message">{error}</p>}
                                    {successMessage && <p className="success-message">{successMessage}</p>}
                                    <form onSubmit={handleRegister}>
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                        <input
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                        <input
                                            type="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <button type="submit" className="button primary-button">Register</button>
                                        <button type="button" onClick={() => setShowRegister(false)} className="button secondary-button">Cancel</button>
                                    </form>
                                </div>
                            )}
                        </main>
                    </div>
                    <footer>
                        <p>&copy; 2024 TypeTalk. All rights reserved.</p>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default MainPage;